import { render, staticRenderFns } from "./AuthorBottomFooter.vue?vue&type=template&id=6ec0c0d4&scoped=true&"
import script from "./AuthorBottomFooter.vue?vue&type=script&lang=js&"
export * from "./AuthorBottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./AuthorBottomFooter.vue?vue&type=style&index=0&id=6ec0c0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0c0d4",
  null
  
)

export default component.exports